<template>
    <BaseModal
        :isVisible="modalStatus"
        title="Informações do Veículo"
        size="xl"
        @close="close"
    >
        <template v-slot:content>
            <!-- Header com informações do veículo -->
            <VehicleHeader
                :vehicle-data="reserve"
                :show-button-user="false"
            />

            <div class="vehicle-header mb-4">
                <div class="form-group row">
                    <div class="col-md-12">
                        <label for="observation">
                            <span class="required">*</span>
                            Observação:
                        </label>
                        <textarea
                            class="form-control"
                            v-model="observation"
                            rows="3"
                        ></textarea>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <button
                            class="btn btn-add mb-2"
                            @click="$emit('save-observation', observation)"
                        >
                            Salvar Observação
                        </button>
                    </div>
                </div>
            </div>

            <div class="vehicle-header mb-4">
                <div class="row">
                    <div class="col-md-12 mb-3 title-centered">
                        Alterar Status
                    </div>
                    <div
                        class="col-md-4"
                        align="center"
                    >
                        <button
                            @click="$emit('change-divergence', 1)"
                            class="btn btn-green"
                        >
                            Finalizar
                        </button>
                    </div>
                    <div
                        class="col-md-4"
                        align="center"
                    >
                        <a
                            @click="$emit('change-divergence', 2)"
                            class="btn btn-blue"
                        >Em andamento
                        </a
                        >
                    </div>
                    <div
                        class="col-md-4"
                        align="center"
                    >
                        <a
                            @click="$emit('change-divergence', 3)"
                            class="btn btn-red"
                        >Reprovar
                        </a
                        >
                    </div>
                </div>
            </div>

            <div
                class="w-100"
                v-if="dataModal.observations.length > 0"
            >
                <div
                    class="row"
                    style="padding: 15px"
                >
                    <div class="col-md-12 title-centered mb-4">
                        Histórico de Observações
                    </div>
                    <div
                        class="vehicle-header mb-4 w-100"
                        v-for="observation in dataModal.observations"
                        :key="observation.id"
                    >
                        {{ observation.created_at }}
                        <span
                            style="text-transform: uppercase; font-weight: bold"
                        >{{ observation.user.name }}
                        </span
                        >
                        : {{ observation.observation }}
                    </div>
                </div>
            </div>

        </template>
    </BaseModal>
</template>

<script>
import BaseModal from "../Base/BaseModal.vue";
import VehicleHeader from "../Modals/Checklist/VehicleHeader.vue";
import CheckForm from "../Modals/Checklist/CheckForm.vue";

export default {
    components: {
        BaseModal,
        VehicleHeader,
        CheckForm
    },

    props: {
        modalStatus: {
            type: Boolean,
            default: false
        },
        reserve: {
            type: Object,
            required: true
        },
    },

    emits: ["close", "change-divergence", "save-observation"],

    data() {
        return {
            observation: '',
            dataModal: {},
        }
    },

    watch: {
        reserve: {
            handler(newValue) {
                this.dataModal = newValue;
            },
            immediate: true
        }
    },

    methods: {
        close() {
            this.$emit("close");
        },
    },
};
</script>

<style scoped>
.comment {
    margin-top: 15px;
    background-color: #efefef;
    padding: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/DivergenceModal.vue